import { Box, Text } from '@chakra-ui/react';
import React from 'react';

import { getGreetingForTime } from 'packages/common-frontend/utils';

export const GSHomeTEMP: React.FC<{
  borrowerName: string;
}> = ({ borrowerName }) => {
  return (
    <Box>
      <Box fontSize={{ base: '16px', sm: '20px', md: '24px' }}>
        {getGreetingForTime()}
      </Box>
      <Text fontSize={{ base: '8px', sm: '12px', md: '16px' }} color="gray">
        {borrowerName}
      </Text>
    </Box>
  );
};
